import { Check } from "@phosphor-icons/react";
import { BlockNavRailProps } from "lib/types/discountAchiever";

export const BlockNavRail = ({ items, activeId, onSelect }: BlockNavRailProps) => (
  <div className="  flex flex-col gap-1 items-center px-2 w-[106px] shrink-0">
    {items.map((item) => {
      const isActive = item.id === activeId;
      const isFulfilled = item.current >= item.target;

      return (
        <button
          key={item.id}
          type="button"
          onClick={() => onSelect(item.id)}
          className={`flex flex-col gap-1 items-center justify-center pt-4 pb-2 px-2 rounded-lg w-full ${
            isActive ? "bg-black/[0.06]" : ""
          } hover:bg-black/[0.04] cursor-pointer`}>
          <div
            className="relative rounded-xl size-[52px]"
            style={{
              boxShadow: isActive
                ? "0 0 0 2px #ffffff, 0 0 0 4px var(--flo-primary-dark-color)"
                : undefined,
            }}>
            <div className="absolute inset-0 size-full object-cover rounded-xl z-10" style={{ boxShadow: "inset 0 0 0 2px rgba(0, 0, 0, 0.08)" }}></div>
            <img
              src={item.thumbnail}
              alt={item.label}
              className="absolute inset-0 size-full object-cover rounded-xl"
            />
            {/* Fulfilled: dark overlay on the thumbnail with a centered check instead of the badge tick */}
            {isFulfilled && (
              <div className="absolute inset-0 z-10 flex items-center justify-center rounded-xl bg-black/40">
                <Check size={20} weight="bold" color="white" />
              </div>
            )}
            {item.showCount && (
              <div className="-translate-x-1/2 absolute z-20 bg-coal-dark flex items-center gap-0.5 justify-center left-1/2 px-1.5 rounded-full top-[-9px] whitespace-nowrap">
                <span className="text-text-xxs-bold text-white">
                  {item.current}/{item.target}
                </span>
              </div>
            )}
          </div>
          <p
            className={`text-text-xs-medium text-center w-full truncate ${
              isActive ? "text-coal-light" : "text-gray-dark"
            }`}>
            {item.label}
          </p>
        </button>
      );
    })}
  </div>
);
